import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cancelSameDayCancellation } from "@/http/sameDayCancellationApi";
import { getSameDayCancellationsQueryKey } from "@/utils/queryKeys";

interface DeleteSameDayCancellationParams {
  phone: string;
  id: number;
}

export const useDeleteSameDayCancellationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ phone, id }: DeleteSameDayCancellationParams) => {
      return cancelSameDayCancellation(phone, id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getSameDayCancellationsQueryKey(),
      });
    },
  });
};
